import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Paper,
  Table,
  TableBody,
} from '@material-ui/core';

import i18n from '../../i18n';

import EcommTableHeader from './EcommTableHeader';
import EcommTableFooter from './EcommTableFooter';
import EcommDataDateAndNameRow from './EcommDataDateAndNameRow';
import EcommDataSpecialProjectRow from './EcommDataSpecialProjectRow';
import EcommDataProductTierRow from './EcommDataProductTierRow';
import EcommDataNumberRow from './EcommDataNumberRow';

class EcommDataCopyPrepTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      copyPrepData: {
        ...props.copyPrepData
      }
    };
  }

  handleChange = (event, key) => {
    event.persist();
    const { name, value } = event.target;
    const keyValues = { [name]: value };
    const { saveOne } = this.props;
    this.setState(prevState => ({
      copyPrepData: {
        ...prevState.copyPrepData,
        [key]: {
          ...prevState.copyPrepData[key],
          [name]: value
        }
      }
    }),
    () => {
      if (value) {
        const { copyPrepData } = this.state;
        saveOne({
          date: copyPrepData[key].date,
          locationType: 'copyprep',
          locationId: copyPrepData[key].locationId,
          keyValues,
          updatedAt: new Date().getTime() / 1000
        })
      }
    });
  };

  handleSpecialProjectChange = (event, key) => {
    event.persist();
    const { name, value } = event.target;
    const { saveOne } = this.props;
    // value === -1 is 'None'
    const isSpecialProject = value !== -1;
    const projectName = isSpecialProject ? value : null;
    const keyValues = { [name]: projectName, isSpecialProject };
    this.setState(prevState => ({
      copyPrepData: {
        ...prevState.copyPrepData,
        [key]: {
          ...prevState.copyPrepData[key],
          [name]: projectName,
          isSpecialProject,
        }
      }
    }),
    () => {
      const { copyPrepData } = this.state;
      saveOne({
        date: copyPrepData[key].date,
        locationType: 'copyprep',
        locationId: copyPrepData[key].locationId,
        keyValues,
        updatedAt: new Date().getTime() / 1000
      });
    });
  };

  getTabIndex = (column)=> {
    const { startTabIndex } = this.props;
    return startTabIndex + column
  }

  render() {
    const { copyPrepData } = this.state;
    const {
      handleDatePickerChange,
      date,
      fetchPrevious,
      fetchNext,
      getNow,
      specialProjectOptions,
      canEdit
    } = this.props;
    return (
      <Paper className="ecommForm">
        <Table>
          <EcommTableHeader
            headerKey="CopyPrepTitle"
            tableTitle={i18n.t('location:copyPrepTableTitle')}
          />
          <TableBody>
            <EcommDataDateAndNameRow
              date={date}
              fetchNext={fetchNext}
              fetchPrevious={fetchPrevious}
              handleDatePickerChange={handleDatePickerChange}
              locationNames={Object.keys(copyPrepData).map(element =>
                copyPrepData[element].copyPrepName)}
            />
            <EcommDataNumberRow
              getTabIndex={this.getTabIndex}
              canEdit={canEdit}
              handleChange={this.handleChange}
              locationData={copyPrepData}
              rowTitle={i18n.t('location:stylesToReceive').toUpperCase()}
              valueKey="stylesToReceive"
            />
            <EcommDataSpecialProjectRow
              canEdit={canEdit}
              getTabIndex={this.getTabIndex}
              locationData={copyPrepData}
              specialProjectOptions={specialProjectOptions}
              handleSpecialProjectChange={this.handleSpecialProjectChange}
            />
            <EcommDataProductTierRow
              canEdit={canEdit}
              getTabIndex={this.getTabIndex}
              locationData={copyPrepData}
              handleChange={this.handleChange}
            />
          </TableBody>
          <EcommTableFooter getNow={getNow} />
        </Table>
      </Paper>
    );
  }
}

EcommDataCopyPrepTable.propTypes = {
  copyPrepData: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.string])
  ).isRequired,
  specialProjectOptions: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]).isRequired,
  handleDatePickerChange: PropTypes.func.isRequired,
  fetchPrevious: PropTypes.func.isRequired,
  fetchNext: PropTypes.func.isRequired,
  saveOne: PropTypes.func.isRequired,
  startTabIndex: PropTypes.number,
  getNow: PropTypes.func.isRequired,
  canEdit: PropTypes.bool.isRequired,
  date: PropTypes.instanceOf(Date).isRequired,
};

EcommDataCopyPrepTable.defaultProps = {
  startTabIndex: 400
}

export default EcommDataCopyPrepTable;
